import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
let accessToken =localStorage.getItem('accessToken')
let userMessage=localStorage.getItem('userMessage')
if(accessToken){
    accessToken= JSON.parse(accessToken)
}
if(userMessage){
    userMessage= JSON.parse(userMessage)
}
export default new Vuex.Store({
    state:{
        access_token: accessToken||null ,
        user:userMessage||null ,
        message:"",
    },
    mutations:{
        StoreLogin(state,value) {
          state.access_token=value;
          localStorage.setItem('accessToken',JSON.stringify(value));
        },
       getUser(state,value) {
        state.user=value;
        localStorage.setItem('userMessage',JSON.stringify(value));
       },
       loginOut(
           state
       ){
           state.access_token=null;
           state.user=null;
           state.message=""
           localStorage.removeItem('accessToken');
           localStorage.removeItem('userMessage');
       }
    },
    actions: {},
    modules: {}
})


// WEBPACK FOOTER //
// ./src/store/index.js